const singletons = new Map();

// Group match stream. `onInit(state)` gets the full snapshot on (re)connect;
// `onEvent(name, data)` gets each delta: participant_joined | participant_left |
// locked | vote | closed. Auto-reconnects; the server resends a fresh init each time,
// so no delta is ever permanently missed. Returns a cleanup function.
export function openMatchStream(base, token, onInit, onEvent) {
  let closed = false;
  let es = null;
  const EVENTS = ["participant_joined", "participant_left", "locked", "vote", "closed"];

  const connect = () => {
    if (closed) return;
    const url = `${base}/match/stream?token=${encodeURIComponent(token)}`;
    es = new EventSource(url, { withCredentials: false });

    es.addEventListener("init", (e) => {
      try { onInit(JSON.parse(e.data)); } catch {}
    });
    for (const name of EVENTS) {
      es.addEventListener(name, (e) => {
        let data = null;
        try { data = JSON.parse(e.data); } catch {}
        onEvent(name, data);
      });
    }
    es.onerror = () => {
      if (closed) return;
      try { es.close(); } catch {}
      setTimeout(connect, 900);
    };
  };

  connect();

  return () => {
    closed = true;
    try { es && es.close(); } catch {}
  };
}

export function openChatStream(base, sessionId, token, onInit, onMessage) {
  const key = `${sessionId}::${token}`;
  if (singletons.has(key)) {
    try {
      const prev = singletons.get(key);
      prev.es && prev.es.close();
    } catch {}
    singletons.delete(key);
  }

  let closed = false;
  const url = `${base}/chat/stream?sessionId=${encodeURIComponent(sessionId)}&token=${encodeURIComponent(token)}`;
  const es = new EventSource(url, { withCredentials: false });

  const handleInit = (e) => {
    try {
      const data = JSON.parse(e.data);
      onInit(Array.isArray(data) ? data : []);
    } catch {
      onInit([]);
    }
  };

  const handleMsg = (e) => {
    try {
      const data = JSON.parse(e.data);
      onMessage(data);
    } catch {}
  };

  const handleErr = () => {
    if (closed) return;
    try { es.close(); } catch {}
    singletons.delete(key);
    setTimeout(() => {
      if (!closed) {
        openChatStream(base, sessionId, token, onInit, onMessage);
      }
    }, 900);
  };

  es.addEventListener("init", handleInit);
  es.addEventListener("message", handleMsg);
  es.onerror = handleErr;

  singletons.set(key, { es });

  return () => {
    closed = true;
    try { es.removeEventListener("init", handleInit); } catch {}
    try { es.removeEventListener("message", handleMsg); } catch {}
    try { es.close(); } catch {}
    singletons.delete(key);
  };
}
